

































































































import FooterButton from "@/components/FooterButton.vue";
import { Component, Mixins, Watch } from "vue-property-decorator";
import { AppData } from "@/models/app-data";
import { required, maxLength, minLength, numeric, minValue } from "vuelidate/lib/validators";
import CommonMixin, { County } from "@/mixins/common-mixins";
import { WorkflowService } from "@/service/workflow.service";
import { EligibilityService } from "@/service/eligibility.service";
import { ZipCodeService } from "@/service/zipcode.service";
import { Workflow } from "../models/workflow";
import UUID from "uuid-js";
import { InitialRequirementsContent } from "@/models/content/initial-requirements";
import { ContentService } from "@/service/content.service";
import { Address } from "@/models/address";
import PageLoader from "@/components/PageLoader.vue"
import { ZipCode } from "@/models/zipcode";

@Component({
  components: {
    FooterButton,
    PageLoader
  },
  validations: {
    zipCode: {
      required,
      maxLength: maxLength(5),
      minLength: minLength(5),
      numeric
    },
    numberOfPeople: {
      required,
      numeric,
      minValue: minValue(1),
      maxLength: maxLength(2)
    },
    numberThreeOrYounger: {
      required,
      numeric
    },
    numberFour: {
      required,
      numeric
    }
  }
})
export default class InitialRequirements extends Mixins(CommonMixin) {
  workflowService = new WorkflowService();
  eligibilityService = new EligibilityService();
  zipcodeService = new ZipCodeService();
  content: InitialRequirementsContent = {} as InitialRequirementsContent;
  PercentDone = 33;
  IsLoading = false;
  appData = {} as AppData;
  zipCode = "";
  county = County.Unknown; 
  numberOfPeople = 0;
  numberThreeOrYounger = 0;
  numberFour = 0;
  textDirection = 'ltr'
  language = ''
  zipCodeData: Array<ZipCode>  = []
  showPageLoader = true

  async mounted(): Promise<void> {
    const contentService = new ContentService(this.$route);
    this.content = await contentService.getInitialRequirementsContent();
    this.textDirection = contentService.TextDirection();
    this.language = contentService.Language()
    this.zipCodeData = await this.zipcodeService.GetActiveZipCodeData();

    const data = this.getAppData();
    if ( data != null){
      this.appData = data;
      this.zipCode = this.appData.zipCode;
      this.county = County.Unknown; 
      this.numberOfPeople = this.appData.numberInHousehold;
      this.numberThreeOrYounger = this.appData.numberChildren - this.appData.number4YearOlds;
      this.numberFour = this.appData.number4YearOlds;
      this.putWorkflowStep( this.appData.workflowId, "InitialRequirements") 
    }
    this.showPageLoader = false;
  }

  public async handleNextPageEvent(): Promise<void> {
    try {
      this.IsLoading = true;
      const workflow = await this.GetOrCreateWorkflow(this.appData.workflowId);
      await this.UpdateWorkflow(workflow);
      const workflowId = workflow.workflowid;
      const income = await this.eligibilityService.getEligibilityIncome(workflowId);
      this.saveData(workflow, income);
      this.nextPage();
    } catch (err) {
      this.showError(`Could not save data, ${err}`);
    }
    this.IsLoading = false;
  }

  public nextPage(): void {
    if (this.appData.liveInDetroit) {
      if (this.appData.numberChildren == 0) {
        this.$router.push({ path: "SorryNotArea" });
      } else {
        this.$router.push({ path: "IncomeRange" });
      }
    } else {
      this.$router.push({ path: "SorryNotArea" });
    }
  }

  async GetOrCreateWorkflow(workflowId: string): Promise<Workflow> {
    let workflow!: Workflow;

    if (workflowId != null) {
      workflow = await this.workflowService.get(workflowId);
    }

    if (workflow == null) {
      const workflowData = {} as Workflow;
      workflowData.step = "InitialRequirements";
      workflowData.phonenumber = `web-${UUID.create().toString()}`;
      workflowData.language = this.language;
      workflow = await this.workflowService.create(workflowData);
    }

    return workflow;
  }

  @Watch("zipCode")
  onZipCodeChange(): void {
    this.county = this.zipCodeToCounty(this.zipCode, this.zipCodeData);
  }

  async UpdateWorkflow(workflow: Workflow): Promise<Workflow> {
      const liveInDetroit = this.IsIncludedZipCode(this.zipCode)
      workflow.numberinhousehold = this.numberOfPeople;
      workflow.numberchildren = this.numberThreeOrYounger + this.numberFour;
      workflow.number4yearolds = this.numberFour;
      workflow.liveindetroit = liveInDetroit;
      if ( workflow.address == null) {
        workflow.address = {} as Address;
      }
      workflow.address.zipcode = this.zipCode;
      workflow.address.county = this.county;

      return await this.workflowService.update(workflow.workflowid, workflow);
  }

  IsIncludedZipCode( zipCode: string): boolean {
    return this.zipCodeData.some( z => z.zipcode === zipCode);
  }

  saveData(workflow: Workflow, income: number): void {
    this.appData.workflowId = workflow.workflowid;
    this.appData.eligibleIncome = income;
    this.appData.liveInDetroit = workflow.liveindetroit;
    this.appData.zipCode = this.zipCode;
    this.appData.county = this.county;
    this.appData.numberInHousehold = this.numberOfPeople;
    this.appData.number4YearOlds = this.numberFour;
    this.appData.numberChildren = this.numberThreeOrYounger + this.numberFour;
    this.appData.numberOfChildrenApplying = this.appData.numberChildren;
    this.saveAppData(this.appData);
  }

  disableNext(): boolean {
    return this.$v.$invalid || this.IsLoading === true;
  }

  @Watch("numberOfPeople")
  onNumPeopleCahnged(): void {
    if (String(this.numberOfPeople).length > 2) {
      this.numberOfPeople = +this.numberOfPeople.toString().substring(0,2)
    }
  }
}
